import { More } from "@mui/icons-material";

export interface Category {
  name: string;
  slug: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: "General Contractors",
    slug: "general-contractors",
    count: 19487,
  },
  {
    name: "Roofing Contractors",
    slug: "roofing-contractors",
    count: 12229,
  },
  {
    name: "Painting Contractors",
    slug: "painting-contractors",
    count: 10520,
  },
  {
    name: "Bathroom Remodeling",
    slug: "bathroom-remodeling",
    count: 10312,
  },
  {
    name: "Home Improvements",
    slug: "home-improvements",
    count: 10306,
  },
  {
    name: "Kitchen Planning & Remodeling Service",
    slug: "kitchen-planning-remodeling-service",
    count: 9782,
  },
  {
    name: "Plumbers",
    slug: "plumbers",
    count: 9590,
  },
  {
    name: "Altering & Remodeling Contractors",
    slug: "altering-remodeling-contractors",
    count: 9362,
  },
  {
    name: "Building Contractors",
    slug: "building-contractors",
    count: 9300,
  },
  {
    name: "Flooring Contractors",
    slug: "flooring-contractors",
    count: 9174,
  },
  {
    name: "Concrete Contractors",
    slug: "concrete-contractors",
    count: 8756,
  },
  {
    name: "Landscape Contractors",
    slug: "landscape-contractors",
    count: 8651,
  },
  {
    name: "Windows-Repair, Replacement & Installation",
    slug: "windows-repair-replacement-installation",
    count: 8481,
  },
  {
    name: "Air Conditioning Contractors & Systems",
    slug: "air-conditioning-contractors-systems",
    count: 8408,
  },
  {
    name: "Siding Contractors",
    slug: "siding-contractors",
    count: 8250,
  },
  {
    name: "Electricians",
    slug: "electricians",
    count: 7734,
  },
  {
    name: "Heating Contractors & Specialties",
    slug: "heating-contractors-specialties",
    count: 7349,
  },
  {
    name: "Building Materials",
    slug: "building-materials",
    count: 7266,
  },
  {
    name: "Home Builders",
    slug: "home-builders",
    count: 6374,
  },
  {
    name: "Landscaping & Lawn Services",
    slug: "landscaping-lawn-services",
    count: 6143,
  },
  {
    name: "Building Contractors-Commercial & Industrial",
    slug: "building-contractors-commercial-industrial",
    count: 4979,
  },
  {
    name: "Swimming Pool Construction",
    slug: "swimming-pool-construction",
    count: 4842,
  },
  {
    name: "Windows",
    slug: "windows",
    count: 4664,
  },
  {
    name: "Landscape Designers & Consultants",
    slug: "landscape-designers-consultants",
    count: 3888,
  },
  {
    name: "Home Repair & Maintenance",
    slug: "home-repair-maintenance",
    count: 3592,
  },
  {
    name: "Irrigation Systems & Equipment",
    slug: "irrigation-systems-equipment",
    count: 3562,
  },
  {
    name: "Air Conditioning Service & Repair",
    slug: "air-conditioning-service-repair",
    count: 3491,
  },
  {
    name: "Gutters & Downspouts",
    slug: "gutters-downspouts",
    count: 3416,
  },
  {
    name: "Lawn Maintenance",
    slug: "lawn-maintenance",
    count: 3214,
  },
  {
    name: "Tile-Contractors & Dealers",
    slug: "tile-contractors-dealers",
    count: 3165,
  },
  {
    name: "Sprinklers-Garden & Lawn",
    slug: "sprinklers-garden-lawn",
    count: 3121,
  },
  {
    name: "Patio Builders",
    slug: "patio-builders",
    count: 2759,
  },
  {
    name: "Plumbing-Drain & Sewer Cleaning",
    slug: "plumbing-drain-sewer-cleaning",
    count: 2616,
  },
  {
    name: "Doors, Frames, & Accessories",
    slug: "doors-frames-accessories",
    count: 2611,
  },
  {
    name: "Construction Consultants",
    slug: "construction-consultants",
    count: 2563,
  },
  {
    name: "Sprinklers-Garden & Lawn, Installation & Service",
    slug: "sprinklers-garden-lawn-installation-service",
    count: 2319,
  },
  {
    name: "Drywall Contractors",
    slug: "drywall-contractors",
    count: 2280,
  },
  {
    name: "Swimming Pool Repair & Service",
    slug: "swimming-pool-repair-service",
    count: 2272,
  },
  {
    name: "Swimming Pool Equipment & Supplies",
    slug: "swimming-pool-equipment-supplies",
    count: 2253,
  },
  {
    name: "Floor Materials",
    slug: "floor-materials",
    count: 2222,
  },
  {
    name: "Masonry Contractors",
    slug: "masonry-contractors",
    count: 2212,
  },
  {
    name: "Landscaping Equipment & Supplies",
    slug: "landscaping-equipment-supplies",
    count: 2161,
  },
  {
    name: "Real Estate Developers",
    slug: "real-estate-developers",
    count: 2111,
  },
  {
    name: "Insulation Contractors",
    slug: "insulation-contractors",
    count: 2093,
  },
  {
    name: "Deck Builders",
    slug: "deck-builders",
    count: 1980,
  },
  {
    name: "Tree Service",
    slug: "tree-service",
    count: 1902,
  },
  {
    name: "Roofing Contractors-Commercial & Industrial",
    slug: "roofing-contractors-commercial-industrial",
    count: 1867,
  },
  {
    name: "Handyman Services",
    slug: "handyman-services",
    count: 1839,
  },
  {
    name: "Water Heater Repair",
    slug: "water-heater-repair",
    count: 1836,
  },
  {
    name: "Carpenters",
    slug: "carpenters",
    count: 1803,
  },
  {
    name: "Sewer Cleaners & Repairers",
    slug: "sewer-cleaners-repairers",
    count: 1677,
  },
  {
    name: "Gardeners",
    slug: "gardeners",
    count: 1645,
  },
  {
    name: "Major Appliances",
    slug: "major-appliances",
    count: 1638,
  },
  {
    name: "Water Heaters",
    slug: "water-heaters",
    count: 1600,
  },
  {
    name: "Plumbing Contractors-Commercial & Industrial",
    slug: "plumbing-contractors-commercial-industrial",
    count: 1579,
  },
  {
    name: "Hardware Stores",
    slug: "hardware-stores",
    count: 1575,
  },
  {
    name: "Swimming Pool Dealers",
    slug: "swimming-pool-dealers",
    count: 1530,
  },
  {
    name: "Hardwood Floors",
    slug: "hardwood-floors",
    count: 1528,
  },
  {
    name: "Electric Companies",
    slug: "electric-companies",
    count: 1520,
  },
  {
    name: "Cabinets",
    slug: "cabinets",
    count: 1511,
  },
  {
    name: "Air Conditioning Equipment & Systems",
    slug: "air-conditioning-equipment-systems",
    count: 1508,
  },
  {
    name: "Door Repair",
    slug: "door-repair",
    count: 1498,
  },
  {
    name: "Roofing Services Consultants",
    slug: "roofing-services-consultants",
    count: 1497,
  },
  {
    name: "Electric Contractors-Commercial & Industrial",
    slug: "electric-contractors-commercial-industrial",
    count: 1493,
  },
  {
    name: "Furnaces-Heating",
    slug: "furnaces-heating",
    count: 1461,
  },
  {
    name: "Sewer Contractors",
    slug: "sewer-contractors",
    count: 1436,
  },
  {
    name: "Painting Contractors-Commercial & Industrial",
    slug: "painting-contractors-commercial-industrial",
    count: 1431,
  },
  {
    name: "Heating Equipment & Systems",
    slug: "heating-equipment-systems",
    count: 1421,
  },
  {
    name: "Cabinet Makers",
    slug: "cabinet-makers",
    count: 1306,
  },
  {
    name: "Building Specialties",
    slug: "building-specialties",
    count: 1303,
  },
  {
    name: "Roofing Equipment & Supplies",
    slug: "roofing-equipment-supplies",
    count: 1244,
  },
  {
    name: "Building Construction Consultants",
    slug: "building-construction-consultants",
    count: 1228,
  },
  {
    name: "Kitchen Cabinets & Equipment-Household",
    slug: "kitchen-cabinets-equipment-household",
    count: 1219,
  },
  {
    name: "Heating Equipment & Systems-Repairing",
    slug: "heating-equipment-systems-repairing",
    count: 1191,
  },
  {
    name: "Carpet & Rug Dealers",
    slug: "carpet-rug-dealers",
    count: 1182,
  },
  {
    name: "Heating, Ventilating & Air Conditioning Engineers",
    slug: "heating-ventilating-air-conditioning-engineers",
    count: 1141,
  },
  {
    name: "Foundation Contractors",
    slug: "foundation-contractors",
    count: 1127,
  },
  {
    name: "Counter Tops",
    slug: "counter-tops",
    count: 1117,
  },
  {
    name: "Plumbing, Drains & Sewer Consultants",
    slug: "plumbing-drains-sewer-consultants",
    count: 1107,
  },
  {
    name: "Home Centers",
    slug: "home-centers",
    count: 1089,
  },
  {
    name: "Swimming Pool Designing & Consulting",
    slug: "swimming-pool-designing-consulting",
    count: 975,
  },
  {
    name: "Basement Contractors",
    slug: "basement-contractors",
    count: 969,
  },
  {
    name: "Glass-Auto, Plate, Window, Etc",
    slug: "glass-auto-plate-window-etc",
    count: 962,
  },
  {
    name: "Fence-Sales, Service & Contractors",
    slug: "fence-sales-service-contractors",
    count: 960,
  },
  {
    name: "Paint",
    slug: "paint",
    count: 892,
  },
  {
    name: "Masonry Contractors-Commercial & Industrial",
    slug: "masonry-contractors-commercial-industrial",
    count: 852,
  },
  {
    name: "Paving Contractors",
    slug: "paving-contractors",
    count: 817,
  },
  {
    name: "Construction Management",
    slug: "construction-management",
    count: 797,
  },
  {
    name: "Snow Removal Service",
    slug: "snow-removal-service",
    count: 774,
  },
  {
    name: "Plumbing Fixtures, Parts & Supplies",
    slug: "plumbing-fixtures-parts-supplies",
    count: 768,
  },
  {
    name: "Plate & Window Glass Repair & Replacement",
    slug: "plate-window-glass-repair-replacement",
    count: 759,
  },
  {
    name: "Siding Materials",
    slug: "siding-materials",
    count: 722,
  },
  {
    name: "Leak Detecting Service",
    slug: "leak-detecting-service",
    count: 721,
  },
  {
    name: "Excavation Contractors",
    slug: "excavation-contractors",
    count: 721,
  },
  {
    name: "Demolition Contractors",
    slug: "demolition-contractors",
    count: 707,
  },
  {
    name: "Professional Engineers",
    slug: "professional-engineers",
    count: 695,
  },
  {
    name: "Heat Pumps",
    slug: "heat-pumps",
    count: 678,
  },
  {
    name: "Fireplaces",
    slug: "fireplaces",
    count: 676,
  },
  {
    name: "Fire & Water Damage Restoration",
    slug: "fire-water-damage-restoration",
    count: 674,
  },
  {
    name: "Mechanical Contractors",
    slug: "mechanical-contractors",
    count: 664,
  },
  {
    name: "Water Damage Restoration",
    slug: "water-damage-restoration",
    count: 659,
  },
  {
    name: "Vinyl Windows & Doors",
    slug: "vinyl-windows-doors",
    count: 651,
  },
  {
    name: "Door & Window Screens",
    slug: "door-window-screens",
    count: 649,
  },
  {
    name: "Driveway Contractors",
    slug: "driveway-contractors",
    count: 648,
  },
  {
    name: "Shower Doors & Enclosures",
    slug: "shower-doors-enclosures",
    count: 645,
  },
  {
    name: "Spas & Hot Tubs",
    slug: "spas-hot-tubs",
    count: 640,
  },
  {
    name: "Sunrooms & Solariums",
    slug: "sunrooms-solariums",
    count: 640,
  },
  {
    name: "Storm Windows & Doors",
    slug: "storm-windows-doors",
    count: 638,
  },
  {
    name: "Granite",
    slug: "granite",
    count: 638,
  },
  {
    name: "Water Damage Emergency Service",
    slug: "water-damage-emergency-service",
    count: 637,
  },
  {
    name: "Bathtubs & Sinks-Repair & Refinish",
    slug: "bathtubs-sinks-repair-refinish",
    count: 621,
  },
  {
    name: "Carpet Installation",
    slug: "carpet-installation",
    count: 600,
  },
  {
    name: "Skylights",
    slug: "skylights",
    count: 593,
  },
  {
    name: "Waterproofing Contractors",
    slug: "waterproofing-contractors",
    count: 591,
  },
  {
    name: "Lawn & Garden Equipment & Supplies",
    slug: "lawn-garden-equipment-supplies",
    count: 586,
  },
  {
    name: "Concrete Products",
    slug: "concrete-products",
    count: 581,
  },
  {
    name: "Lumber",
    slug: "lumber",
    count: 579,
  },
  {
    name: "Irrigation Consultants",
    slug: "irrigation-consultants",
    count: 577,
  },
  {
    name: "Building Materials-Wholesale & Manufacturers",
    slug: "building-materials-wholesale-manufacturers",
    count: 558,
  },
  {
    name: "Kitchen Cabinets-Refinishing, Refacing & Resurfacing",
    slug: "kitchen-cabinets-refinishing-refacing-resurfacing",
    count: 553,
  },
  {
    name: "Tools",
    slug: "tools",
    count: 552,
  },
  {
    name: "Bathroom Fixtures, Cabinets & Accessories",
    slug: "bathroom-fixtures-cabinets-accessories",
    count: 546,
  },
  {
    name: "Wallpapers & Wallcoverings-Installation",
    slug: "wallpapers-wallcoverings-installation",
    count: 523,
  },
  {
    name: "Faux Painting & Finishing",
    slug: "faux-painting-finishing",
    count: 519,
  },
  {
    name: "Lighting Contractors",
    slug: "lighting-contractors",
    count: 518,
  },
  {
    name: "Air Duct Cleaning",
    slug: "air-duct-cleaning",
    count: 517,
  },
  {
    name: "Drainage Contractors",
    slug: "drainage-contractors",
    count: 514,
  },
  {
    name: "Cleaning Contractors",
    slug: "cleaning-contractors",
    count: 512,
  },
  {
    name: "Gutters & Downspouts Cleaning",
    slug: "gutters-downspouts-cleaning",
    count: 509,
  },
  {
    name: "Construction Engineers",
    slug: "construction-engineers",
    count: 505,
  },
  {
    name: "Asphalt Paving & Sealcoating",
    slug: "asphalt-paving-sealcoating",
    count: 503,
  },
  {
    name: "Mirrors",
    slug: "mirrors",
    count: 501,
  },
  // Add more...
];
